var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    fill: "#260C6A",
    rx: 18.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    stroke: "#fff",
    strokeWidth: 3,
    rx: 18.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    fillRule: "evenodd",
    d: "M25.557 9.383a6.23 6.23 0 0 0-4.383 1.748 1.5 1.5 0 1 0 2.084 2.158 3.23 3.23 0 0 1 4.576 4.56l-2.828 2.828a3.23 3.23 0 0 1-4.872-.349 1.5 1.5 0 1 0-2.402 1.797 6.232 6.232 0 0 0 9.396.673l2.838-2.838.018-.019a6.23 6.23 0 0 0-4.427-10.558m-6.718 5.42a6.23 6.23 0 0 0-4.85 1.81h-.001L11.15 19.45l-.018.018a6.23 6.23 0 0 0 8.81 8.81 1.5 1.5 0 1 0-2.085-2.158 3.23 3.23 0 0 1-4.576-4.56l2.828-2.827a3.23 3.23 0 0 1 3.834-.552 1.5 1.5 0 1 0 1.438-2.632 6.2 6.2 0 0 0-2.542-.747",
    clipRule: "evenodd"
  })));
};
export default SvgLink;